export const resolutionStatusEnum = ['OUI', 'NON', 'DOUTE'] as const
export type ResolutionStatus = (typeof resolutionStatusEnum)[number]

export const resolutionStatusLabels: Record<ResolutionStatus, string> = {
  OUI: 'Résolu',
  NON: 'Non résolu',
  DOUTE: 'Doute',
}
